import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "drop",
  "use": "drop-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"drop\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.9981 0C4.03493 0 0 4.03873 0 9.00189C0 13.9613 4.03493 18 8.9981 18C13.9613 18 18 13.9613 18 9.00189V0.0151547C14.9994 0.011366 11.9987 0.00378868 8.9981 0Z\" fill=\"#B7C13F\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol